import Attachment from './AttachmentView'
export default Attachment
